import {
    type FC
} from "react";
import {
    Platform,
    View
} from "react-native";
import type IQuestionnaireChoicesProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    QuestionnaireItemPartContentProps
} from "../../type";
import {
    withQuestionnaireItemContext
} from "../../context";
import {
    getQuestionnaireSelectBehaviour
} from "../../util";
import QuestionnaireChoice from "../choice";

const QuestionnaireChoicesContent: FC<QuestionnaireItemPartContentProps<IQuestionnaireChoicesProps>> = ({
    customTheme: customThemeProp,
    itemContext,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const isSingle = getQuestionnaireSelectBehaviour(itemContext.item) === "single";

    const groupProps = isSingle ? {
        "aria-labelledby": Platform.OS === "web" ? itemContext.titleId : undefined,
        role: "radiogroup" as const
    } : {};

    return <View
        {...props}
        {...groupProps}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {
            children ?? (itemContext.item.choices ?? []).map((choice, index) => <QuestionnaireChoice
                customTheme={customThemeProp}
                key={choice.value}
                choice={choice}
                index={index}
            />)
        }
    </View>;
};
export default withQuestionnaireItemContext("Choices", QuestionnaireChoicesContent);
